import { close, config, open } from "layer-esm";
import { getAppliedTheme } from "./theme";
const DIALOG_HORIZONTAL_CHROME = 42;
let activeDialogIndex = null;
function isPositiveDimension(value) {
    return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function getPreferredDimensions(context, sourceImage) {
    if (isPositiveDimension(sourceImage.naturalWidth) &&
        isPositiveDimension(sourceImage.naturalHeight)) {
        return {
            width: sourceImage.naturalWidth,
            height: sourceImage.naturalHeight,
        };
    }
    if (isPositiveDimension(context.image.width) &&
        isPositiveDimension(context.image.height)) {
        return {
            width: context.image.width,
            height: context.image.height,
        };
    }
    return null;
}
export function closeImageDetailDialog() {
    if (activeDialogIndex === null) {
        return;
    }
    const dialogIndex = activeDialogIndex;
    activeDialogIndex = null;
    close(dialogIndex);
}
export function openImageDetailDialog(context, event, title) {
    closeImageDetailDialog();
    const sourceImage = event.currentTarget;
    const targetDocument = sourceImage.ownerDocument;
    const detailImage = targetDocument.createElement("img");
    const preferredDimensions = getPreferredDimensions(context, sourceImage);
    detailImage.className = "image-detail-dialog__image";
    detailImage.src = sourceImage.currentSrc || context.image.src;
    detailImage.alt = context.image.alt;
    detailImage.decoding = "async";
    if (preferredDimensions &&
        preferredDimensions.width === sourceImage.naturalWidth &&
        preferredDimensions.height === sourceImage.naturalHeight) {
        detailImage.width = preferredDimensions.width;
        detailImage.height = preferredDimensions.height;
    }
    config({ theme: getAppliedTheme(targetDocument) });
    let titleElement = null;
    let closeButton = null;
    const handleTitleKeyDown = (keyboardEvent) => {
        if (keyboardEvent.key === "Tab" &&
            keyboardEvent.shiftKey &&
            closeButton) {
            keyboardEvent.preventDefault();
            closeButton.focus();
        }
    };
    let dialogIndex = -1;
    dialogIndex = open({
        title,
        content: detailImage,
        area: "auto",
        btn: false,
        shadeClose: true,
        closeBtn: true,
        move: false,
        resize: false,
        scrollbar: false,
        isOutAnim: false,
        className: "image-detail-dialog",
        maxWidth: preferredDimensions
            ? preferredDimensions.width + DIALOG_HORIZONTAL_CHROME
            : undefined,
        targetDocument,
        success: (layerElement) => {
            const titleId = layerElement.getAttribute("aria-labelledby");
            titleElement = titleId ? targetDocument.getElementById(titleId) : null;
            closeButton = layerElement.querySelector(".layer-esm__toolbar-button--close");
            if (!titleElement || !closeButton) {
                return;
            }
            titleElement.tabIndex = -1;
            titleElement.addEventListener("keydown", handleTitleKeyDown);
            titleElement.focus({ preventScroll: true });
        },
        end: () => {
            titleElement?.removeEventListener("keydown", handleTitleKeyDown);
            titleElement = null;
            closeButton = null;
            if (activeDialogIndex === dialogIndex) {
                activeDialogIndex = null;
            }
        },
    });
    activeDialogIndex = dialogIndex;
}
